// extracted by mini-css-extract-plugin
module.exports = {"lia-list":"PageEditorWidgetListContent_lia-list__tQ_g9","lia-heading":"PageEditorWidgetListContent_lia-heading__Wdi6z"};